import { DocumentFields } from "modules/self-apply/validation/candidate-self-apply";
import { MultiFieldSet } from "@/utils/useFieldSet";
import { PublicJobSectionGraph } from "../../../../../graphql.types";
import { UploadDocumentRow } from "../../../../components/self-apply-application-form-fragments/documents";
import { SelfApplySectionContainer } from "../../../../components/self-apply-section-container";

export const SelfApplyCandidateDocumentsAppSection = (props: {
  section: PublicJobSectionGraph;
  documents: MultiFieldSet<DocumentFields>;
}) => {
  const { section, documents } = props;

  function updateDocument(
    orgDocId: number,
    transform: (document: DocumentFields) => DocumentFields,
  ) {
    const index = documents?.values?.findIndex(
      (x) => x.orgcustomdocumentsId === orgDocId,
    );
    documents.setItem(index, transform(documents?.values?.[index]));
  }

  if (section?.jobCandidateDocuments?.length > 0) {
    const hasAtLeastOneRequiredDocument = section?.jobCandidateDocuments?.some(
      (doc) => doc?.isRequired,
    );

    return (
      <SelfApplySectionContainer.Container
        description={section.description ?? ""}
        title={section.name ?? ""}
        isRequired={hasAtLeastOneRequiredDocument}
      >
        <SelfApplySectionContainer.Content>
          <ul className="flex flex-col gap-y-2 pt-4">
            {section?.jobCandidateDocuments
              ?.filter((x) => !x?.isDeleted)
              ?.map((documentDefinition) => {
                const showValidation =
                  documents?.isDirty?.some(
                    (i) => Object.values(i)?.some((x) => x),
                  ) && documentDefinition?.isRequired;

                return (
                  <li key={documentDefinition?.id}>
                    <UploadDocumentRow
                      docName={
                        documentDefinition?.docName
                          ? `${documentDefinition?.docName} (PDF ONLY)`
                          : ""
                      }
                      required={documentDefinition?.isRequired ?? false}
                      onUpload={(file) => {
                        updateDocument(
                          documentDefinition?.orgDocId as number,
                          (existingDocument) => ({
                            ...existingDocument,
                            file: file.file ?? undefined,
                            isFinalStep: false,
                          }),
                        );
                      }}
                      onDelete={() => {
                        updateDocument(
                          documentDefinition?.orgDocId as number,
                          (existingDocument) => ({
                            ...existingDocument,
                            file: undefined,
                            createdAt: undefined,
                          }),
                        );
                      }}
                      shouldShowValidation={showValidation}
                      validationMessage={"This document is required."}
                      uploadedDate={
                        documents?.values?.find(
                          (x) =>
                            x.orgcustomdocumentsId ===
                            documentDefinition?.orgDocId,
                        )?.createdAt
                      }
                    />
                  </li>
                );
              })}
          </ul>
        </SelfApplySectionContainer.Content>
      </SelfApplySectionContainer.Container>
    );
  }
  return null;
};
